/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Footer_CnaInputs */

const en_subscription_footer_cna = /** @type {(inputs: Subscription_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership will NOT auto-renewal after it expires.`)
};

const ar_subscription_footer_cna = /** @type {(inputs: Subscription_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership will NOT auto-renewal after it expires.`)
};

const de_subscription_footer_cna = /** @type {(inputs: Subscription_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership will NOT auto-renewal after it expires.`)
};

const es_subscription_footer_cna = /** @type {(inputs: Subscription_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership will NOT auto-renewal after it expires.`)
};

const fr_subscription_footer_cna = /** @type {(inputs: Subscription_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership will NOT auto-renewal after it expires.`)
};

const it_subscription_footer_cna = /** @type {(inputs: Subscription_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership will NOT auto-renewal after it expires.`)
};

const ja_subscription_footer_cna = /** @type {(inputs: Subscription_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership will NOT auto-renewal after it expires.`)
};

const ko_subscription_footer_cna = /** @type {(inputs: Subscription_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership will NOT auto-renewal after it expires.`)
};

const pt_br_subscription_footer_cna = /** @type {(inputs: Subscription_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership will NOT auto-renewal after it expires.`)
};

const ru_subscription_footer_cna = /** @type {(inputs: Subscription_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership will NOT auto-renewal after it expires.`)
};

const th_subscription_footer_cna = /** @type {(inputs: Subscription_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership will NOT auto-renewal after it expires.`)
};

const tr_subscription_footer_cna = /** @type {(inputs: Subscription_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership will NOT auto-renewal after it expires.`)
};

const zh_cn_subscription_footer_cna = /** @type {(inputs: Subscription_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 会员到期后不会自动续费。`)
};

const zh_tw_subscription_footer_cna = /** @type {(inputs: Subscription_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 会员到期后不会自动续费。`)
};

/**
* | output |
* | --- |
* | "Plus Membership will NOT auto-renewal after it expires." |
*
* @param {Subscription_Footer_CnaInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_footer_cna = /** @type {((inputs?: Subscription_Footer_CnaInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Footer_CnaInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_footer_cna(inputs)
	if (locale === "ar") return ar_subscription_footer_cna(inputs)
	if (locale === "de") return de_subscription_footer_cna(inputs)
	if (locale === "es") return es_subscription_footer_cna(inputs)
	if (locale === "fr") return fr_subscription_footer_cna(inputs)
	if (locale === "it") return it_subscription_footer_cna(inputs)
	if (locale === "ja") return ja_subscription_footer_cna(inputs)
	if (locale === "ko") return ko_subscription_footer_cna(inputs)
	if (locale === "pt_br") return pt_br_subscription_footer_cna(inputs)
	if (locale === "ru") return ru_subscription_footer_cna(inputs)
	if (locale === "th") return th_subscription_footer_cna(inputs)
	if (locale === "tr") return tr_subscription_footer_cna(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_footer_cna(inputs)
	return zh_tw_subscription_footer_cna(inputs)
});